import { Injectable } from '@angular/core';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TRoute, TTicket } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class RoutesService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getObservable(): any {
        const path = this.firestorePathsService.getRoutesPath();
        const observable = this.firestoreService.getObservable(path);
        return observable;
    }

    public async getByUid(uid: string): Promise<any> {
        const path = this.firestorePathsService.getRoutesPath();
        return this.firestoreService.getByUid(path, uid);
    }

    // public async getByFieldValue(fieldName, fieldValue): Promise<TRoute[]> {
    //     const path = this.firestorePathsService.getRoutesPath();
    //     return this.firestoreService.getByFieldValue(path, fieldName, fieldValue) as Promise<TRoute[]>;
    // }
    public async getByFieldValue<K extends keyof TRoute>(
        fieldName: K,
        fieldValue: TRoute[K]
    ): Promise<TRoute[]> {
        const path = this.firestorePathsService.getRoutesPath();
        return this.firestoreService.getByFieldValue(path, fieldName, fieldValue) as Promise<TRoute[]>;
    }


    public async getAll(): Promise<TRoute[]> {
        const path = this.firestorePathsService.getRoutesPath();
        return this.firestoreService.getAll(path) as Promise<TRoute[]>;
    }

    public async add(route: TRoute): Promise<TRoute> {
        const path = this.firestorePathsService.getRoutesPath();
        return this.firestoreService.add(path, route) as Promise<TRoute>;
    }

    public async set(route: TRoute): Promise<TRoute> {
        const path = this.firestorePathsService.getRoutesPath();
        return await this.firestoreService.set(path, route) as Promise<TRoute>;
    }

    public async update(route: TRoute): Promise<TRoute> {
        const path = this.firestorePathsService.getRoutesPath();
        return this.firestoreService.update(path, route) as Promise<TRoute>;
    }

    public async delete(uid: string): Promise<void> {
        const path = this.firestorePathsService.getRoutesPath();
        return this.firestoreService.delete(path, uid);
    }

    public async deleteAll(): Promise<void> {
        const routes = await this.getAll();
        routes.forEach(async (route) => {
            await this.delete(route.uid!);
        });
    }

    public async getTickets(uid: string): Promise<TTicket[] | null> {
        const route = await this.getByUid(uid);
        if (route) {
            return route.selectedTickets;
        } else {
            return null;
        }
    }

    public async updateRouteToTraveling(route: TRoute): Promise<TRoute> {
        route.shuttle.status = 'Traveling';
        return this.update(route);
    }
}
